import React from 'react'
import { Body1, Body1Bold } from '../../../components/Typography'
import { ButtonGreen } from '../../../components/Buttons'
import onboardingImage from '../../../assets/images/onboarding.png'
import { InnerInnerBox } from '../../../components/Flex'
import { Loader } from '../../../components/Loader'

export function WelcomeStep({
  goToNextStep,
  loading,
}: {
  goToNextStep: () => void
  loading: boolean
}): React.JSX.Element {
  return (
    <>
      <Body1Bold data-testid='welcome-step'>Välkommen!</Body1Bold>
      <InnerInnerBox>
        <img
          src={onboardingImage}
          alt=''
          style={{
            alignSelf: 'center',
            maxHeight: 328,
            minHeight: 200,
            height: '30vh',
          }}
        />
        <Body1>Välkommen till Svalnas Carbon Intelligence System™</Body1>
        <Body1>
          Vi använder data från ert bokföringssystem för att uppskatta utsläppen
          för varje köp. Allt vi behöver är några uppgifter för att komma igång
          och kvalitetssäkra beräkningarna. Därefter kan ni se var era insatser
          gör störst skillnad för att nå era klimatmål.
        </Body1>
      </InnerInnerBox>
      <ButtonGreen
        style={{ alignSelf: 'center' }}
        onClick={() => {
          goToNextStep()
        }}
        endIcon={
          loading && <Loader size={14} borderSize={2} data-testid='loader' />
        }
        data-testid='next-button'
        disabled={loading}
      >
        Kom igång
      </ButtonGreen>
    </>
  )
}
